import { render, staticRenderFns } from "./SpartanFooter.vue?vue&type=template&id=48005c0b&scoped=true&"
import script from "./SpartanFooter.vue?vue&type=script&lang=js&"
export * from "./SpartanFooter.vue?vue&type=script&lang=js&"
import style0 from "./SpartanFooter.vue?vue&type=style&index=0&id=48005c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48005c0b",
  null
  
)

export default component.exports